import { css, excludeProps, mixins, styled } from '@bob/library'
import { Markdown } from '@websrc/App/Components/Markdown/Markdown'
import { spotCampaignBreakpoint } from '@websrc/Spot/Campaign/Components/SpotCampaignShared.style'
import { SpotLinkAnchor } from '@websrc/Spot/Link/SpotLinkAnchor'

export type SpotCampaignContentStyleProps = {
  hasBackgroundImage: boolean
  backgroundColor: string
  mobile?: boolean
  hasVideo: boolean
}

export const Content = styled.div<SpotCampaignContentStyleProps>`
  ${({ hasBackgroundImage }: SpotCampaignContentStyleProps) =>
    hasBackgroundImage && `padding: 20px 40px;`}

  ${mixins.media.max.custom(spotCampaignBreakpoint)} {
    padding: 25px;
    text-align: center;
  }
  ${mixins.media.max.phone} {
    padding: 20px;
    text-align: start;
  }
  width: 100%;
  min-height: inherit;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: unset;
  ${({ hasBackgroundImage, hasVideo }: SpotCampaignContentStyleProps) =>
    hasBackgroundImage && hasVideo && `display: none;`}
  ${({ hasBackgroundImage, mobile, backgroundColor, hasVideo }: SpotCampaignContentStyleProps) =>
    hasBackgroundImage &&
    !hasVideo &&
    !mobile &&
    css`
      background-color: ${backgroundColor};
      border-radius: 5px;
      box-shadow: 0 10px 22px 11px rgba(0, 0, 0, 0.03), 0 12px 22px rgba(0, 0, 0, 0.03),
        0 1px 23px 3px rgba(0, 0, 0, 0.06);
      align-items: flex-start;
    `};
`

export type TextProps = {
  fontColor?: string
}

export const Headline = styled.h1<TextProps>`
  width: 100%;
  ${mixins.typography.headlineLarge};
  ${mixins.margin(0)};
  color: ${({ fontColor }: TextProps) => fontColor};

  ${mixins.media.max.custom(spotCampaignBreakpoint)} {
    ${mixins.typography.headlineMedium}
  }

  ${mixins.media.max.tablet} {
    ${mixins.typography.headlineSmall}
  }
`

export const Description = styled(Markdown)<TextProps>`
  ${mixins.margin(15, 'auto', 0)};
  ${mixins.typography.paragraphMedium}

  & p {
    ${mixins.margin(0)};
    color: ${({ fontColor }: TextProps) => fontColor};
  }
`

export const StyledAnchor = styled(excludeProps(SpotLinkAnchor, 'hasBackground'))`
  ${mixins.margin.top(40)};

  ${mixins.media.max.custom(spotCampaignBreakpoint)} {
    ${mixins.margin(30, 'auto', 0, 'auto')};
  }

  ${mixins.media.max.phone} {
    ${mixins.margin(30, 0, 0, 0)};
  }
`

export const LearnMoreButtonWrapper = styled.div<{ isSibling: boolean }>`
  width: 100%;
  ${(p: { isSibling: boolean }) => mixins.margin.top(p.isSibling ? 15 : 30)}
`
